import(/* webpackMode: "eager" */ "/app/app/intervyus/page.tsx");
